import { Box, styled } from "@mui/material";

import { MIN_SIDEBAR_WIDTH } from "./constants";

export const LeftSidebarWrapper = styled(Box)({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  minHeight: "100%",

  // Show collapse button on hover of wrapper
  "&:hover > div:last-of-type": {
    opacity: 1,
  },
});

export const LeftSidebarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$width" && prop !== "$isCollapsed",
})<{ $width: number; $isCollapsed: boolean }>(({ theme, $width, $isCollapsed }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  flex: 1, // Expand to fill available height
  width: `var(--leftSidebarWidth, ${$width}px)`, // Use CSS variable for smooth drag, fallback to prop
  flexShrink: 0,
  backgroundColor: $isCollapsed ? theme.palette.background.default : theme.palette.background.paper,
  borderRight: `1px solid ${theme.palette.divider}`,
  // boxShadow: $isCollapsed ? theme.shadows[1] : "none",
  minHeight: "100%",
  zIndex: 200,
  overflow: "hidden", // Clip content during slide
  transition: "width 0.2s ease-in-out, box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out",
}));

export const LeftSidebarContent = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$isCollapsed" && prop !== "$contentWidth",
})<{ $isCollapsed: boolean; $contentWidth: number }>(({ $isCollapsed, $contentWidth }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1, // Expand to fill available height
  width: `var(--leftSidebarWidth, ${$contentWidth}px)`, // Use CSS variable for smooth resize
  minWidth: $isCollapsed ? 0 : MIN_SIDEBAR_WIDTH, // Prevent content from getting too narrow during resize
  flexShrink: 0,
  opacity: $isCollapsed ? 0 : 1,
  visibility: $isCollapsed ? "hidden" : "visible",
  transition: "opacity 0.15s ease-in-out, visibility 0.15s ease-in-out",
  overflow: "auto",
}));
